import { render, staticRenderFns } from "./MessageGroup.vue?vue&type=template&id=6dd81f14&"
import script from "./MessageGroup.vue?vue&type=script&lang=js&"
export * from "./MessageGroup.vue?vue&type=script&lang=js&"
import style0 from "./MessageGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports